<template>
	<div class="project-page-container">
		<div class="main-content">
			<edit-panel />
			<spreading-compaction-edit-panel />
			<chart-board ref="chartboard" class="chart-board-wrapper" />
		</div>
		<v-dialog v-model="showExportDialog" width="32%" max-width="500px" persistent>
			<export-landXML-dialog :name="name" :geometry="geometry" :roadObjForExport="exportObj" :is-obj="isObj"
				@close="closePropertyDialog()" ref="export_dialog" />
		</v-dialog>
		<v-dialog v-model="showExportDialogImage" width="32%" max-width="500px" persistent>
			<export-dialog-Image v-if="showExportDialogImage" :name="name" :geometry="geometry" :imageId="imageId"
				@close="closePropertyDialog()" ref="export_dialog_image" />
		</v-dialog>
		<v-dialog v-model="showExportDialogSolidMesh" width="32%" max-width="500px" persistent>
			<export-solid-mesh-dialog v-if="showExportDialogSolidMesh" :name="name" :geometry="geometry"
				@close="closePropertyDialog()" ref="export_dialog_solid_mesh" />
		</v-dialog>
		<v-dialog v-model="showPropertyDialogRoad" width="72%" max-width="1072px" persistent>
			<property-dialog-road v-if="showPropertyDialogRoad" :id="id" @close="closePropertyDialog()"
				ref="property_dialog_road" />
		</v-dialog>
		<v-dialog v-model="showPropertyDialogTrench" width="72%" max-width="1072px" persistent>
			<property-dialog-trench v-if="showPropertyDialogTrench" :id="id" :type="type" @close="closePropertyDialog()"
				ref="property_dialog_trench" />
		</v-dialog>
		<v-dialog v-model="showPropertyDialogFlat" width="72%" max-width="1072px" persistent>
			<property-dialog-flat v-if="showPropertyDialogFlat" :id="id" :type="type" @close="closePropertyDialog()"
				ref="property_dialog_flat" />
		</v-dialog>
		<v-dialog v-model="showUpdateCtrlPointDialog" width="32%" max-width="1072px" persistent>
			<update-ctrl-point-dialog :id="id" :pointId="pointId" :entityUnderEdit="entityUnderEdit"
				:disabilityConditions="disabilityConditions" :origin="origin" @close="closePropertyDialog()"
				ref="update_ctrl_point_dialog" />
		</v-dialog>
		<v-dialog v-model="showAddRoadTerrainByAI" width="100%" persistent>
			<AddRoadTerrainByAI :id="id" :type="type" @close="closePropertyDialog()" ref="property_dialog_road_ai" />
		</v-dialog>
		<v-dialog v-model="showPrototypeRoadAI" width="100%" persistent eager>
			<PrototypeRoadAI @close="closePropertyDialog()" ref="property_dialog_prototype_road_ai" />
		</v-dialog>
		<v-dialog v-model="showAddRoadByJson" width="100%" persistent>
			<AddRoadByJson :id="id" :type="type" @close="closePropertyDialog()" ref="property_dialog_json" />
		</v-dialog>


		<v-dialog v-model="showExportFromDashboardDialog" max-width="560px" persistent>
			<ExportFromDashboardDialog :id="id" :isShow="showExportFromDashboardDialog" @close="closePropertyDialog()"
				ref="property_dialog_export_from_dashboard" />
		</v-dialog>
		<v-dialog v-model="showArbitraryLineDialog" max-width="460px" persistent>
			<add-arbitrary-line-cross-section-dialog v-if="showArbitraryLineDialog" :viewer-line-id="id"
				@close="closePropertyDialog()" ref="property_dialog_arbitrary_line" />
		</v-dialog>
		<v-dialog v-model="showLineWorksCrossSectionDialog" max-width="460px" persistent>
			<LineWorksCrossSectionDialog :id="id" @close="closePropertyDialog()" ref="line_works_cross_section_dialog">
			</LineWorksCrossSectionDialog>
		</v-dialog>
		<v-dialog v-model="showLineWorksCrossSectionEditDialog" max-width="460px" persistent>
			<line-works-cross-section-edit-dialog v-if="showLineWorksCrossSectionEditDialog"
				:cross-section-data="editCrossSectionData.crossSectionData" :line-works-id="editCrossSectionData.lineWorksId"
				@close="closePropertyDialog()"
				ref="line_works_cross_section_edit_dialog"></line-works-cross-section-edit-dialog>
		</v-dialog>
		<v-dialog v-model="showExportLineworksFormatDialog" max-width="460px" persistent>
			<ExportLineworksFormatDialog v-if="showExportLineworksFormatDialog" :entity="exportLineworksEntity"
				@close="closePropertyDialog()" ref="export_lineworks_format_dialog" />
		</v-dialog>
		<v-dialog v-model="showSelectCoordinateDialog" width="800px" v-if="showSelectCoordinateDialog" persistent>
			<select-site-coordinate-system :site-id="$route.query.siteId" :coordinate-system-pf="coordinateSystemPf"
				:coordinate-system-db="coordinateSystemDb" :is-top-page="false" @update="updateCoordinateSystem" />
		</v-dialog>
		<v-dialog v-model="showPropertyDialogSolidMesh" max-width="460px" persistent>
			<property-dialog-solid-mesh v-if="showPropertyDialogSolidMesh" :id="id" :type="type"
				@close="closePropertyDialog()" ref="property_dialog_solid_mesh">
			</property-dialog-solid-mesh>
		</v-dialog>
		<v-dialog v-model="showPropertyDialogFoundationExcavation" width="95%" max-width="1920px" height="85vh" persistent>
			<property-dialog-foundation-excavation v-if="showPropertyDialogFoundationExcavation" />
		</v-dialog>
		<property-dialog-road v-if="isRoadFromAI" :id="id" :type="type" ref="property_road_ai" :key="id"
			style="display: none;" />
		<ObjectUpdateDialog
    v-model="objectUpdateDialogVisible"
    @submit="onObjectUpdateSubmit"
    @close="onObjectUpdateClose"
  />
	</div>
</template>

<script lang="ts">
import ObjectUpdateDialog from "@/components/Project/ObjectUpdateDialog.vue";
import ExportSolidMeshDialog from "@/components/Project/SolidMesh/ExportSolidMeshDialog.vue";
import PropertyDialogSolidMesh from "@/components/Project/SolidMesh/PropertyDialogSolidMesh.vue";
import { useGlobalDialogs } from "@/composables/useGlobalDialogs.js";
import { useUploadTracker } from "@/composables/useUploadTracker";
import * as cesiumCommon from "@/utils/cesium-common";
import {
	notifyError,
	notifySuccess,
	notifyWarning,
} from "@/utils/notificationUtils";
import objectLockWebSocket from "@/utils/objectLockWebSocket";
import axios from "axios";
import { mapActions, mapMutations } from "vuex";
import SelectSiteCoordinateSystem from "../components/AddData/SelectSiteCoordinateSystem.vue";
import AddRoadByJson from "../components/Project/AddRoadByJson.vue";
import AddRoadTerrainByAI from "../components/Project/AddRoadTerrainByAI.vue";
import ChartBoard from "../components/Project/ChartBoard/ChartBoard.vue";
import EditPanel from "../components/Project/EditPanel.vue";
import ExportDialogImage from "../components/Project/ExportDialogDrawing2DImage.vue";
import ExportFromDashboardDialog from "../components/Project/ExportFromDashboardDialog.vue";
import ExportLandXMLDialog from "../components/Project/ExportLandXMLDialog.vue";
import PropertyDialogFoundationExcavation from "../components/Project/FoundationExcavation/PropertyDialogFoundationExcavation.vue";
import AddArbitraryLineCrossSectionDialog from "../components/Project/LineWorks/AddArbitraryLineCrossSectionDialog.vue";
import ExportLineworksFormatDialog from "../components/Project/LineWorks/ExportLineworksFormatDialog.vue";
import LineWorksCrossSectionDialog from "../components/Project/LineWorks/LineWorksCrossSectionDialog.vue";
import LineWorksCrossSectionEditDialog from "../components/Project/LineWorks/LineWorksCrossSectionEditDialog.vue";
import { defaultLineWorksCrossSection } from "../components/Project/LineWorks/default";
import PropertyDialogFlat from "../components/Project/PropertyDialogFlat.vue";
import PropertyDialogRoad from "../components/Project/PropertyDialogRoad.vue";
import PropertyDialogTrench from "../components/Project/PropertyDialogTrench.vue";
import PrototypeRoadAI from "../components/Project/PrototypeRoadAI.vue";
import SpreadingCompactionEditPanel from "../components/Project/SpreadingCompactionEditPanel.vue";
import UpdateCtrlPointDialog from "../components/Project/UpdateCtrlPointDialog.vue";
import { InProgressMode } from "../store/modules/inprogress-mode-manager";
import localDb from "../utils/local-db";
import * as roadAIUtil from "../utils/roadAIUtils";
import {
	checkPointCloudDataExistence,
	getPreconstructionNode,
	getSiteLatitudeAndLongitude,
	importDashboardPreconstruction,
} from "../utils/sitePreparationUtils";

export default {
	setup() {
		const {
			showPropertyDialogRoad,
			showPropertyDialogTrench,
			showPropertyDialogFlat,
			showPropertyDialogSolidMesh,
			showPropertyDialogFoundationExcavation,
		} = useGlobalDialogs();
		return {
			showPropertyDialogRoad,
			showPropertyDialogTrench,
			showPropertyDialogFlat,
			showPropertyDialogSolidMesh,
			showPropertyDialogFoundationExcavation,
		};
	},
	name: "ProjectPage",
	components: {
		ChartBoard,
		ExportLandXMLDialog,
		ExportDialogImage,
		PropertyDialogRoad,
		PropertyDialogTrench,
		PropertyDialogFlat,
		PropertyDialogSolidMesh,
		PropertyDialogFoundationExcavation,
		ExportSolidMeshDialog,
		UpdateCtrlPointDialog,
		AddRoadTerrainByAI,
		PrototypeRoadAI,
		AddRoadByJson,
		ExportFromDashboardDialog,
		LineWorksCrossSectionDialog,
		LineWorksCrossSectionEditDialog,
		ExportLineworksFormatDialog,
		AddArbitraryLineCrossSectionDialog,
		SelectSiteCoordinateSystem,
		EditPanel,
		ObjectUpdateDialog,
		SpreadingCompactionEditPanel,
	},
	data: () => ({
		isRoadFromAI: false,
		exportObj: null,
		showExportDialog: false,
		showExportDialogImage: false,
		showExportDialogSolidMesh: false,
		showUpdateCtrlPointDialog: false,
		showAddRoadTerrainByAI: false,
		showPrototypeRoadAI: false,
		showAddRoadByJson: false,
		showSegmentSelection: false,
		showExportFromDashboardDialog: false,
		showSelectCoordinateDialog: false,
		showExportLineworksFormatDialog: false,
		id: null,
		type: null,
		pointId: null,
		imageId: null,
		entityUnderEdit: null,
		disabilityConditions: null,
		origin: null,
		startIndex: 0,
		pointsCount: 0,
		name: null,
		geometry: null,
		exportLineworksEntity: null,
		showArbitraryLineDialog: false,
		showLineWorksCrossSectionDialog: false,
		showLineWorksCrossSectionEditDialog: false,
		coordinateSystemDb: null,
		coordinateSystemPf: null,
		isObj: false,
	}),
	beforeCreate() {
		objectLockWebSocket.connect();
	},
	async mounted() {
		const conflictCoordinateSystem =
			this.$store.getters.conflictCoordinateSystem;

		// Check site coordinate system conflicting
		if (conflictCoordinateSystem) {
			this.coordinateSystemDb = conflictCoordinateSystem.design3d;
			this.coordinateSystemPf = conflictCoordinateSystem.otherApp;

			// Show SelectSiteCoordinateSystem dialog
			this.showSelectCoordinateDialog = true;
		} else {
			// Initialization
			await this.initialization();
		}
	},
	unmounted() {
		window.viewer.clear();
		this.set_point_cloud_list([]);
		this.set_design_list([]);
		window.removeEventListener("openPropertyDialog", this.openPropertyDialog);
		window.removeEventListener("registerAiRoad", this.registerAiRoad);
		window.removeEventListener(
			"openLineWorksEditDialog",
			this.openLineWorksEditDialog,
		);
		window.removeEventListener(
			"openExportLineworksFormatDialog",
			this.openExportLineworksFormatDialog,
		);
	},
	computed: {
		objectUpdateDialogVisible() {
			return this.$store.state.object.objectUpdateDialog.visible;
		},
	},
	methods: {
		...mapMutations([
			"set_point_cloud_list",
			"set_design_list",
			"set_snackbar",
		]),
		...mapActions(["get_point_cloud_list", "get_design_list"]),
		...mapActions("drawing2dImage", ["getDrawing2dImageList"]),
		...mapActions("object", ["get_obj_list"]),
		async initialization() {
			window.addEventListener("popstate", () => {
				window.location.href = window.location.origin;
			});
			window.addEventListener("openPropertyDialog", this.openPropertyDialog);
			window.addEventListener("registerAiRoad", this.registerAiRoad);
			window.addEventListener(
				"openLineWorksEditDialog",
				this.openLineWorksEditDialog,
			);
			window.addEventListener(
				"openExportLineworksFormatDialog",
				this.openExportLineworksFormatDialog,
			);
			await this.$nextTick();
			await this.getPointCloudList();
			await this.getDesignList();
			await this._getDrawing2DImageList();
			this.$store.dispatch(
				"measurement/getMeasurementList",
				this.$route.query.siteId,
			);
			this.$store.dispatch(
				"arbitraryLine/getArbitraryLineList",
				this.$route.query.siteId,
			);
			try {
				await this.$store.dispatch(
					"simaLine/getSimaLineList",
					this.$route.query.siteId,
				);
			} catch (e) {
				console.warn("GET SIMA LINE LIST", e);
			}
			const { detectAndTrackPendingItems } = useUploadTracker();
			detectAndTrackPendingItems(
				this.$store.state.point_cloud_list,
				this.$store.state.design_list,
				this.$store.state.simaLine.simaLineList,
				this.$route.query.siteId,
				this.$store.state.drawing2dImage?.drawing2dImageList,
			);
			await this.loadObj(this.$route.query.siteId);
			await this.$store.dispatch("spreadingCompaction/loadAndRestore");
		},
		async updateCoordinateSystem(siteId, updateInfo) {
			// Hide SelectSiteCoordinateSystem dialog
			this.showSelectCoordinateDialog = false;

			this.$store.dispatch("updateIsLoading", true);
			try {
				// If selected platform values, update design3d database
				if (updateInfo) {
					await axios.post(
						`${import.meta.env.VITE_API_BASE}/sites/epsg/${siteId}`,
						updateInfo,
					);
				} else {
					// Regsiter platform if using desing3d data
					try {
						await axios.post(
							`${import.meta.env.VITE_API_BASE}/sites/${siteId}/localizations/export`,
							{
								isDashboard: false,
							},
						);
					} catch (e) {
						// Show snackbar message if localization file is not found
						if (e.response.data?.existLocalizationFile === false) {
							notifyWarning(
								this,
								this.$t("MESSAGE_NOT_FOUND_LOCALIZATION_FILE"),
							);
						} else {
							notifyError(
								this,
								this.$t("MESSAGE_ERROR_FAILED_SET_COORDINATE_SYSTEM"),
							);
						}
					}
				}

				// Get preconstruction data from dashboard if point cloud data does not exist
				if (!(await checkPointCloudDataExistence(siteId))) {
					try {
						const bucketInfo = await getPreconstructionNode(siteId);
						if (bucketInfo) {
							notifySuccess(
								this,
								this.$t("ACQUIRING_POINT_CLOUD_DATA_FROM_OTHER_APP"),
							);
							await importDashboardPreconstruction(siteId, bucketInfo);
						} else {
							throw new Error("Not found preconstruction data.");
						}
					} catch (e) {
						// no operation
					}
				}

				// Focus the site
				const { latitude, longitude } =
					await getSiteLatitudeAndLongitude(siteId);
				const pinId = window.viewer.addPin(
					Number(longitude),
					Number(latitude),
					"#00000000", // Use transparent color to be not display
				);
				window.viewer.focusPin(pinId);

				// Get latest site information and save in store
				await this.$store.dispatch("getSiteInfo", siteId);

				// Remove pin
				window.viewer.removePin(pinId);
			} catch (e) {
				notifyError(
					this,
					this.$t("MESSAGE_ERROR_FAILED_SET_COORDINATE_SYSTEM"),
				);
			} finally {
				this.$store.commit("set_conflict_coordinate_system", null);
				this.$store.dispatch("updateIsLoading", false);
			}

			// Initialization
			await this.initialization();
		},
		async getPointCloudList() {
			try {
				await this.get_point_cloud_list(this.$route.query.siteId);
				//get from localdb and load it
				const storedList = await localDb.getPointClouds(
					this.$store.state.user.id,
					this.$store.state.site.site_uuid,
				);
				const commonList = this.$store.state.point_cloud_list.filter((item) =>
					storedList.includes(item.getAssetId()),
				);
				for (const pointCloud of commonList) {
					if ((await pointCloud.waitAssetUploading()) === "DONE") {
						cesiumCommon.togglePointCloudVisibility(pointCloud);
					}
				}
			} catch (error) {
				console.log("GET POINT CLOUD LIST", error);
			}
		},
		async getDesignList() {
			try {
				await this.get_design_list(this.$route.query.siteId);
				//get from localdb and load it
				const storedList = await localDb.getDesigns(
					this.$store.state.user.id,
					this.$store.state.site.site_uuid,
				);
				const commonList = this.$store.state.design_list.filter((item) =>
					storedList.includes(item.getAssetId()),
				);
				for (const design of commonList) {
					if (design.getIsAssetUploaded() === "DONE") {
						cesiumCommon.toggleDesignVisibility(design);
					}
				}
			} catch (error) {
				console.log("GET DESIGN LIST", error);
			}
		},
		async _getDrawing2DImageList() {
			try {
				await this.getDrawing2dImageList(this.$route.query.siteId);
				//get from localdb and load it
				const storedList = await localDb.getDrawing2DImages(
					this.$store.state.user.id,
					this.$store.state.site.site_uuid,
				);
				const commonList = this.$store.getters[
					"drawing2dImage/getDrawing2dImageList"
				].filter((item) => storedList.includes(item.getAssetId()));
				for (const drawing2dOmage of commonList) {
					cesiumCommon.toggleDrawing2dImageVisibility(drawing2dOmage);
				}
			} catch (error) {
				console.log("GET POINT CLOUD LIST", error);
			}
		},
		async loadObj(siteId) {
			// this.initObj();
			await this.get_obj_list(siteId);
		},
		openLineWorksEditDialog(e) {
			console.log("received entity data", e.detail);
			this.editCrossSectionData = {
				crossSectionData: e.detail.crossSectionSettings,
				lineWorksId: e.detail.lineWorksId,
			};

			this.showLineWorksCrossSectionEditDialog = true;
		},
		openExportLineworksFormatDialog(e) {
			console.log("received export lineworks entity data", e.detail);
			if (!e.detail?.entity) {
				console.error("Export lineworks entity data is missing or invalid");
				return;
			}
			this.exportLineworksEntity = e.detail.entity;
			this.showExportLineworksFormatDialog = true;
		},
		// D3D-774: 提案経路一覧パネルからの登録。プロパティダイアログを開かず、
		// 非表示の property_road_ai 経由でデフォルト値のまま道路オブジェクトを登録する。
		async registerAiRoad(e) {
			this.id = e.detail.id;
			this.type = 0;
			this.isRoadFromAI = true;
			await this.$nextTick();
			await this.$refs.property_road_ai.updateRoadSettings(
				true,
				e.detail.leftWidth,
				e.detail.rightWidth,
			);
			if (e.detail.roadName && this.$refs.property_road_ai) {
				this.$refs.property_road_ai.property.name = e.detail.roadName;
			}
			await this.$refs.property_road_ai.addRoad();
			this.isRoadFromAI = false;
		},
		async openPropertyDialog(e) {
			this.id = e.detail.id;
			this.type = e.detail.type;
			this.pointId = e.detail.pointId;
			this.entityUnderEdit = e.detail.entityUnderEdit;
			this.disabilityConditions = e.detail.disabilityConditions;
			this.origin = e.detail.origin;
			switch (this.type) {
				case 0:
					if (e.detail.isAI) {
						this.isRoadFromAI = true;
						await this.$nextTick();
						const leftWith = this.$store.getters["addRoadTerrainByAi/leftWith"];
						const rightWith =
							this.$store.getters["addRoadTerrainByAi/rightWith"];
						await this.$refs.property_road_ai.updateRoadSettings(
							true,
							leftWith,
							rightWith,
						);
						// prototype 経由の場合は自動生成した道路名を設定する。
						if (e.detail.roadName && this.$refs.property_road_ai) {
							this.$refs.property_road_ai.property.name = e.detail.roadName;
						}
						await this.$refs.property_road_ai.addRoad();
						const addedObj = this.$store.state.object.objects.find(
							(obj) => obj.id === e.detail.id,
						);
						const [cutVolume, fillVolume] =
							await this.calculateRoadVolume(addedObj);
						this.$store.dispatch(
							"addRoadTerrainByAi/update_cut_volume",
							cutVolume,
						);
						this.$store.dispatch(
							"addRoadTerrainByAi/update_fill_volume",
							fillVolume,
						);
						const createRoadText = `作成しました。切土は${cutVolume}㎥、盛り土は${fillVolume}㎥です。作成した道路について説明してください。`;
						this.$store.dispatch("addRoadTerrainByAi/add_post_chat_message", {
							role: "user",
							text: createRoadText,
						});
						const response = await roadAIUtil.executeChatbot(this.$store);
						this.$store.dispatch("addRoadTerrainByAi/add_chat_message", {
							role: "assistant",
							text: response.response,
						});
						this.$store.dispatch("addRoadTerrainByAi/add_post_chat_message", {
							role: "assistant",
							text: response.response,
						});
						this.$store.dispatch("updateIsLoading", false);
						this.isRoadFromAI = false;
					} else {
						this.showPropertyDialogRoad = true;
						this.$refs.property_dialog_road?.resetProperty();
					}
					break;
				case 1:
					this.showPropertyDialogFlat = true;
					this.$refs.property_dialog_flat?.resetProperty();
					break;
				case 2:
					// 仮設道路AI 地形データ選択ダイアログ(W002-09)
					this.showAddRoadTerrainByAI = true;
					this.$refs.property_dialog_road_ai?.resetProperty();

					this.$refs.property_dialog_road_ai?.fetchDesignItems();

					this.$refs.property_dialog_road_ai?.fetchPointCloudItems();
					break;
				case 3:
					this.showUpdateCtrlPointDialog = true;
					this.$refs.update_ctrl_point_dialog?.initCoordinates();
					break;
				case 4:
					// 仮設道路AI設定ダイアログ(W002-10)
					console.log("AddRoadByJson dialog");
					this.showAddRoadByJson = true;
					// 画面初期表示
					this.$refs.property_dialog_json?.setInitialize();
					break;
				case 5:
					// 仮設道路AI設定ダイアログ(W002-10)
					console.log("Show segment Selection dialog");
					//need start index
					//max possibleindex => get from store
					//road id
					//
					console.log("params", e.detail);
					this.startIndex = e.detail.clickedPointIndex;
					this.pointsCount = e.detail.totalPoints;
					this.showSegmentSelection = true;
					break;
				case 6:
					this.name = e.detail.name;
					this.geometry = e.detail.geometry;
					this.exportObj = e.detail.roadObjForExport;
					this.showExportDialog = true;
					this.isObj = e.detail.obj != null;
					this.$refs.export_dialog?.resetProperty();
					break;
				case 7:
					this.showPropertyDialogTrench = true;
					this.$refs.property_dialog_trench?.resetProperty();
					break;
				case 8:
					this.showExportFromDashboardDialog = true;
					this.$refs.property_dialog_export_from_dashboard?.resetProperty();
					break;
				case 9:
					this.showArbitraryLineDialog = true;
					this.$refs.property_dialog_arbitrary_line?.resetProperty();
					break;
				case 10:
					this.showLineWorksCrossSectionDialog = true;
					this.$refs.line_works_cross_section_dialog?.resetProperty();
					break;

				case 12:
					this.name = e.detail.name;
					this.geometry = e.detail.geometry;
					this.imageId = e.detail.imageId;
					this.showExportDialogImage = true;
					this.$refs.export_dialog_image?.resetProperty();
					break;
				case 13:
					this.showPropertyDialogSolidMesh = true;
					this.$refs.property_dialog_solid_mesh?.resetProperty();
					break;
				case 14:
					this.name = e.detail.name;
					this.geometry = e.detail.geometry;
					this.showExportDialogSolidMesh = true;
					this.$refs.export_dialog_solid_mesh?.resetProperty();
					break;
				case 100:
					// 仮設道路AI (prototype / PoC) ダイアログ
					this.showPrototypeRoadAI = true;
					break;
				default:
					break;
			}
		},
		async calculateRoadVolume(obj) {
			obj.loadingVolume = true;
			try {
				const res = await window.viewer.volumeCalculationForRoad(obj.id);
				obj.cutVolume = res.cutVolume.toFixed(3);
				obj.fillVolume = res.fillVolume.toFixed(3);
			} catch (error) {
				console.error(error.message);
			} finally {
				obj.loadingVolume = false;
			}
			this.$forceUpdate();
			return [obj.cutVolume, obj.fillVolume];
		},
		async closePropertyDialog() {
			if (
				this.$store.state.inProgressModeManager.inProgressMode ===
				InProgressMode.CREATION
			) {
				await this.$store.dispatch("inProgressModeManager/cancelCreation");
			}
			this.showExportDialog = false;
			this.showExportDialogImage = false;
			this.showExportDialogSolidMesh = false;
			this.showPropertyDialogRoad = false;
			this.showPropertyDialogTrench = false;
			this.showPropertyDialogFlat = false;
			this.showArbitraryLineDialog = false;
			this.showUpdateCtrlPointDialog = false;
			this.showAddRoadTerrainByAI = false;
			this.showPrototypeRoadAI = false;
			this.showAddRoadByJson = false;
			this.showSegmentSelection = false;
			this.showExportFromDashboardDialog = false;
			if (this.$refs.property_dialog_road) {
				this.$refs.property_dialog_road.isRoadAdded = false;
			}
			if (this.$refs.property_dialog_trench) {
				this.$refs.property_dialog_trench.isTrenchAdded = false;
			}
			if (this.$refs.property_dialog_flat) {
				this.$refs.property_dialog_flat.isFlatGroundAdded = false;
			}

			this.showLineWorksCrossSectionDialog = false;
			this.showLineWorksCrossSectionEditDialog = false;
			this.showExportLineworksFormatDialog = false;
			this.entityLineId = null;
			this.exportLineworksEntity = null;
			this.showPropertyDialogSolidMesh = false;
		},
		roadAICreation() {
			// ToolPanelのref経由でメソッドを呼ぶ
			this.$refs.tool_panel.roadAICreation();
		},
		reRoadAiCreation() {
			// ToolPanelのref経由でメソッドを呼ぶ
			this.$refs.tool_panel.reRoadAiCreation();
		},
		closeAiChatbot() {
			this.showAiChatbot = false;
			const isStartAndEndPoint = this._hasEmptyValues();
			if (isStartAndEndPoint) {
				window["viewer"].cancelRoadCreation();
			} else {
				roadAIUtil.resetDefaultValue(this.$store);
			}
		},
		_hasEmptyValues() {
			const points = roadAIUtil.getStartEndPoint(this.$store);
			for (const key in points) {
				if (points[key] === undefined) {
					return true;
				}
			}
			return false;
		},
		async onObjectUpdateSubmit(value) {
			this.$store.dispatch("object/closeObjectUpdateDialog", value);
		},
		onObjectUpdateClose() {
			this.$store.dispatch("object/closeObjectUpdateDialog", null);
		},
	},
};
</script>

<style scoped>
.project-page-container {
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;
}

.main-content {
	display: flex;
	flex-direction: row;
	flex: 1;
	min-height: 0;
}

.chart-board-wrapper {
	flex: 1;
	min-height: 0;
	overflow: hidden;
}
</style>
